<template>
    <div class="ranking">
        <div class="tit">
            <img src="@/assets/common/titLogo.png"
                 alt="">
            <span>
                {{
					lotteryType == 0 ? '双色球':
					lotteryType == 1 ? '大乐透':
					lotteryType == 2 ? '福彩3D':
					lotteryType == 3 ? '排列三':''
				}}指标排名
            </span>
        </div>
        <div class="cont">
            <div class="nav">
                <span v-for="(item,index) in rankingArr"
                      :key="index"
                      :class="rankingActive == index ? 'active' : ''"
                      @click="rankingActive = index;getRanking()">{{item}}</span>
            </div>
            <div class="table">
                <div class="thead">
                    <span>名次</span>
                    <span>缩水师</span>
                    <span>成绩</span>
                    <span>积分</span>
                    <span>升降</span>
                </div>
                <div v-for="(item, index) in db"
                     :key="index"
                     class="tbody">
                    <template v-if="index<=2">
                        <span class="qiansan"
                              v-if="index == 0"> <img src="@/assets/common/rank/1.gif"
                                 alt=""> </span>
                        <span class="qiansan"
                              v-if="index == 1"> <img src="@/assets/common/rank/2.gif"
                                 alt=""></span>
                        <span class="qiansan"
                              v-if="index == 2"> <img src="@/assets/common/rank/3.gif"
                                 alt=""></span>
                    </template>
                    <span v-else>{{ index + 1 }}</span>

                    <span @click="view_history(
						item,
						(
							lotteryType == 0 ? 'ssq':
							lotteryType == 1 ? 'dlt':
							lotteryType == 2 ? 'fcse':
							lotteryType == 3 ? 'pls':''
						)
					)" style="cursor: pointer;color:#4084b4">{{item.nickName}}</span>
                    <span>{{item.achievement}}</span>
                    <span>{{item.totalScore}}</span>
                    <span v-if="item.ifResi == '0'">降</span>
                    <span v-if="item.ifResi == '1'">平</span>
                    <span v-if="item.ifResi == '2'">升</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { queryPreRankingList } from "@/api/home"
import {} from '@/api/home'
export default {
    props: ['rankingArr', 'lotteryType'],
    data () {
        return {
            rankingActive: 0,
            db: []
        };
    },
    watch: {
    },
    mounted () {
        this.getRanking()
    },
    methods: {
		// 查看历史记录
		view_history (item, preType) {

			this.$router.push({
				path: '/dating_viewHistory',
				query:{
					shrinkId: item.shrinkId || item.createUser,
					number: item.number,
					userName: item.nickName,
					preType,
				}
			})
			
			// this.$router.addRoute({
			// 	path: '/dating_viewHistory',
			// 	name: 'dating_viewHistory', // 假设你有一个名字
			// 	component: () => import('@/views/homePage/menu/suoshuidan_dating/components/viewHistory.vue')
			// })

			// const routeExists = this.$router.options.routes.some(route => route.name === 'dating_viewHistory');
			// let trim = setInterval(() => {
			// 	if (!routeExists) {
			// 		clearInterval(trim)
			// 		// 使用全局前置守卫来执行操作
			// 		this.$router.push({
			// 			path: '/dating_viewHistory',
			// 			query: {
			// 				item,
			// 				preIndexType:item.preIndexType,
			// 				preType:this.lotteryType,
			// 				backNumber:item.number

			// 			}
			// 		})
			// 	}

			// }, 100)

			// this.$refs.viewHistory.init(item, preIndexType, preType, backNumber)
		},
        getRanking () {
            // this.$message.error('指标排名接口不能用')
            // return
            // 指标排名

			let preIndexType = []

			if(['2','3'].includes(this.lotteryType)){
				preIndexType = [5,0,1,2,3,4]
			}else{
				preIndexType = [7,0,1,2,3,4,5,6]
			}


            queryPreRankingList({
                preType: this.lotteryType,
                preIndexType: preIndexType[this.rankingActive] ,
                risingNo: 10,
            }).then(res => {
                this.db = res.data;
            })
        },
    }
};
</script>

<style lang="scss" scoped>
.ranking {
	height: 100%;
    .tit {
        font-weight: bold;
        margin-bottom: 10px;
        display: flex;
        align-items: center;

        img {
            width: 20px;
        }

        span {
            margin-left: 10px;
        }
    }

    .cont {
		height: calc(100% - 33px);
        .nav {
            display: flex;
            border-right: 1px solid #8fb3da;

            span {
                cursor: pointer;
                white-space: nowrap;
                font-size: 14px;
                padding: 5px;
                border: 1px solid #8fb3da;
                border-right: 0;
                background-color: #e8e8e8;
                flex: 1;
                text-align: center;

                &.active {
                    background-color: #ffffff;
                    font-weight: bold;
                    border-bottom: 1px solid #ffffff;
                }
            }
        }

        .table {
            border: 1px solid #8fb3da;
            border-top: 0;
            // font-weight: bold;
            padding-top: 10px;
			height: 92%;
            > div {
                display: grid;
                grid-template-columns: 10% 30% 20% 30% 10%;
                grid-auto-flow: column;
                border-bottom: 1px solid rgba(0, 0, 0, 0.07);

                span {
                    text-align: center;
                    padding: 10.8px 0;
					white-space: nowrap;
                }
            }

            .qiansan {
                padding: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    width: 13px;
                }
            }
        }
    }
}
</style>